import { useContext } from "react";
import { PortalContext } from "../../../context/Provider";
import "./MantenimientoCard.css";
import {
  mantenimientoDescripcion,
  mantenimientoTitulo,
} from "./MantenimientoTxt";

const MantenimientoCard = () => {
  const { textosState } = useContext(PortalContext);

  return (
    <div className="ptur-mantenimientoCard-container">
      <div className="ptur-mantenimientoCard-header bgcG-latex30">
        <span className="ptur-mantenimientoCard-txt rb24b">
          {textosState?.textos?.data?.msjPortalMantenimiento?.nombre
            ? textosState?.textos?.data?.msjPortalMantenimiento?.nombre
            : mantenimientoTitulo}
        </span>
      </div>
      <div className="ptur-mantenimientoCard-body">
        <div>
          {textosState?.textos?.data?.msjPortalMantenimiento?.descripcion ? (
            <span
              className="ptur-mantenimientoCard-bodyTxtSuperior rb24t"
              dangerouslySetInnerHTML={{
                __html:
                  textosState?.textos?.data?.msjPortalMantenimiento?.descripcion,
              }}
            ></span>
          ) : (
            <span className="ptur-mantenimientoCard-bodyTxtSuperior rb24t">
              {mantenimientoDescripcion}
            </span>
          )}
        </div>
        <button className="btn bgc-primary c-white rb14m" onClick={() => {window.location.reload()}}>Recargar página</button>
      </div>
    </div>
  );
};

export default MantenimientoCard;
